var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53559 0.616382L2.27923 0.210415C2.97665 -0.169847 3.84446 0.0609441 4.30701 0.749389L5.22803 2.12095C5.62871 2.7182 5.6229 3.51289 5.21374 4.0851L4.07317 5.67806C4.31196 6.4539 4.72878 7.18247 5.32287 7.86391C5.88968 8.52474 6.58333 9.06512 7.36273 9.45305L8.93113 8.5705C9.52525 8.23687 10.2645 8.3473 10.7635 8.84464L11.9283 10.0028C12.5095 10.5813 12.6045 11.5147 12.1512 12.187L11.666 12.9075C11.1824 13.6247 10.368 14.0084 9.52864 13.9134C7.54567 13.6904 5.49403 12.2899 3.37075 9.71246C1.24441 7.13102 0.218367 4.78982 0.293918 2.69167C0.325509 1.80876 0.797414 1.01901 1.53559 0.616382Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.5adb1c9175131f67436b531723c4138c.svg";
export { ForwardRef as ReactComponent };